<ion-content>
  <div class="checkmark-design">
    <ion-icon name="checkmark"></ion-icon>
  </div>
  <h1 class="title-text">
    {{'pay-confirmation.Your' | translate}} <br />
    {{'pay-confirmation.successful' | translate}}
  </h1>
  <div class="notes">
    <p>{{'pay-confirmation.page' | translate}}</p>
    <p>{{'pay-confirmation.play' | translate}}</p>
  </div>

  <ion-button size="small" expand="block" (click)="goToCompleteRegistrationPage()" class="action-btn-large"
    type="submit">{{'pay-confirmation.Next' | translate}}</ion-button>
</ion-content>